const MuiTableCell = {
  root: {
    borderBottom: 'none',
  },
};

export default MuiTableCell;
